import React, { useState } from "react";
import HeroAddress from "../heroAddress/HeroAddress";
import heroImage from "../../assets/images/banner.webp";
import "./FAQ.css";

const mostPopularFAQs = [
  { question: "Do you offer a birthday deal?", anchor: "birthday-deal" },
  { question: "What are your buffet prices?", anchor: "buffet-prices" },
];

const faqSections = [
  {
    category: "Restaurant Info",
    faqs: [
      {
        id: "hours",
        question: "What are your hours?",
        answer: (
          <div>
            <strong>Monday – Friday</strong>
            <br />
            🍱 <strong>Lunch:</strong> 11:00 AM – 3:00 PM
            <br />
            🍜 <strong>Dinner:</strong> 4:30 PM – 9:30 PM
            <br />
            <br />
            <strong>Saturday – Sunday & Holidays</strong>
            <br />
            🎟️ <strong>All Day:</strong> 11:00 AM – 9:30 PM{" "}
            <em>(Weekend Pricing Applies)</em>
          </div>
        ),
      },
      {
        id: "birthday-deal",
        question: "Do you offer a birthday deal?",
        answer: (
          <>
            <strong>Absolutely!</strong> Enjoy a{" "}
            <strong>free birthday meal</strong> when you visit us on your
            birthday. Just bring a <strong>valid photo ID</strong> and let our
            staff know when you arrive.
          </>
        ),
      },
      {
        id: "reservations",
        question: "Can we make a reservation?",
        answer: (
          <>
            We welcome <strong>walk-ins</strong> every day, but if you're
            planning a party of <strong>15 or more</strong>, please call us at{" "}
            <strong>(303) 873-9999</strong>. We'll do our best to accommodate
            your group!
          </>
        ),
      },
      {
        id: "parking",
        question: "Is there parking available?",
        answer: (
          <>
            <strong>Yes!</strong> We offer <strong>free on-site parking</strong>{" "}
            for all our guests to make your visit as easy as possible.
          </>
        ),
      },
      {
        id: "pets",
        question: "Are pets allowed?",
        answer: (
          <>
            To ensure everyone’s comfort, only{" "}
            <strong>trained service animals</strong> are permitted.{" "}
            <strong>Emotional support animals</strong> are not allowed under our
            current policy.
          </>
        ),
      },
      {
        id: "wheelchair",
        question: "Do you have wheelchair access?",
        answer: (
          <>
            <strong>Yes</strong>, our restaurant is fully{" "}
            <strong>wheelchair accessible</strong>, including entrances and
            restrooms, so all guests feel welcome.
          </>
        ),
      },
    ],
  },
  {
    category: "Buffet & Arcade",
    faqs: [
      {
        id: "buffet-prices",
        question: "What are your buffet prices?",
        answer: (
          <>
            We offer different pricing for <strong>lunch</strong>,{" "}
            <strong>dinner</strong>, and <strong>weekends</strong>. Visit our{" "}
            <a href="/buffet-pricing">
              <strong>Buffet Pricing</strong>
            </a>{" "}
            page for full details.
          </>
        ),
      },
      {
        id: "kids-pricing",
        question: "Do you offer kids pricing?",
        answer: (
          <>
            <strong>Yes!</strong> We offer{" "}
            <strong>discounted pricing for children</strong> based on age and
            height. See our{" "}
            <a href="/buffet-pricing">
              <strong>Buffet Pricing</strong>
            </a>{" "}
            page for full info.
          </>
        ),
      },
      {
        id: "drinks",
        question: "Are drinks included?",
        answer: (
          <>
            Drinks are <strong>not included</strong> with the buffet, but can be
            ordered separately. Visit our{" "}
            <a href="/drinks">
              <strong>Drinks</strong>
            </a>{" "}
            menu for available options.
          </>
        ),
      },
      {
        id: "arcade-launch",
        question: "When is your arcade coming out?",
        answer: (
          <>
            We're <strong>excited</strong> to open our new arcade! It's
            currently being <strong>remodeled</strong> and will be launching{" "}
            <strong>very soon</strong>. Stay tuned!
          </>
        ),
      },
    ],
  },
  {
    category: "Other Questions",
    faqs: [
      {
        id: "vegetarian",
        question: "Do you have vegan options?",
        answer: (
          <>
            We offer a few <strong>vegan-friendly options</strong> including{" "}
            <strong>green beans</strong>, <strong>broccoli</strong>,{" "}
            <strong>fresh fruit</strong>, and <strong>rice</strong>. Please note
            that some items like <strong>lo mein</strong> and{" "}
            <strong>rice noodles</strong> may contain eggs. Feel free to ask our
            staff for suggestions!
          </>
        ),
      },
      {
        id: "msg",
        question: "Do you use MSG in your food?",
        answer: (
          <>
            We do <strong>not add MSG</strong> directly to our food. However,
            some dishes contain <strong>chicken broth</strong> which may have{" "}
            <strong>naturally occurring glutamates</strong>. Let us know if you
            have any dietary concerns!
          </>
        ),
      },
      {
        id: "giftcards",
        question: "How can we purchase gift cards?",
        answer: (
          <>
            <strong>Gift cards</strong> are available at our{" "}
            <strong>front desk</strong>. Just ask one of our friendly team
            members and they'll help you out!
          </>
        ),
      },
      {
        id: "contact",
        question: "Still have questions?",
        answer: (
          <>
            We're here to help! Visit our{" "}
            <a href="/contact">
              <strong>Contact Page</strong>
            </a>{" "}
            or give us a call at <strong>(303) 873-9999</strong>. We’ll be happy
            to assist you.
          </>
        ),
      },
    ],
  },
  {
    category: "Payment & Policies",
    faqs: [
      {
        id: "payment-methods",
        question: "What forms of payment do you accept?",
        answer: (
          <>
            We accept <strong>cash</strong>, major <strong>credit cards</strong>{" "}
            (Visa, MasterCard, Discover), and <strong>mobile payments</strong>{" "}
            (Apple Pay, Google Pay).
          </>
        ),
      },
      {
        id: "refunds-policy",
        question: "Do you offer refunds or rain checks?",
        answer: (
          <>
            Due to the nature of buffet dining, we are{" "}
            <strong>unable to offer refunds once seated</strong>. If you have a
            concern, please speak with a manager so we can assist you.
          </>
        ),
      },
      {
        id: "sanitizer",
        question: "Is hand sanitizer available?",
        answer: (
          <>
            Yes, we provide <strong>sanitizer stations</strong> at key areas
            like entrances and buffet stations for your safety and convenience.
          </>
        ),
      },
    ],
  },
];

const FAQPage = () => {
  const [openItems, setOpenItems] = useState({});
  const toggleFAQ = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="faq-page">
      <HeroAddress
        title="Frequently Asked Questions"
        imageUrl={heroImage}
        className="faq-banner"
      />

      <div className="faq-main-wrapper">
        <div className="faq-content">
          {faqSections.map((section, sIdx) => (
            <div key={sIdx} className="faq-section">
              <h2 className="faq-category">{section.category}</h2>
              {section.faqs.map((faq, fIdx) => {
                const index = `${sIdx}-${fIdx}`;
                return (
                  <div key={index} id={faq.id} className="faq-item">
                    <button
                      className="faq-question"
                      onClick={() => toggleFAQ(index)}
                    >
                      {faq.question}
                      <span className="faq-icon">
                        {openItems[index] ? "▲" : "▼"}
                      </span>
                    </button>
                    {openItems[index] && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <aside className="faq-sidebar">
          <div className="popular-box">
            <h3>Most Popular FAQs</h3>
            <ul>
              {mostPopularFAQs.map((item, i) => (
                <li key={i}>
                  <a href={`#${item.anchor}`}>{item.question}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="contact-box">
            <h4>Can’t find your question?</h4>
            <a className="contact-btn" href="/contact">
              Contact Us
            </a>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default FAQPage;
